import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@/i18n/resources/en.json";
import es from "@/i18n/resources/es.json";
import pt from "@/i18n/resources/pt.json";
import type { SupportedLocale } from "@/types/auth";

export const supportedLocales: SupportedLocale[] = ["en", "es", "pt"];

let initializationPromise: Promise<typeof i18n> | null = null;

export function initializeI18n() {
  if (i18n.isInitialized) {
    return Promise.resolve(i18n);
  }

  if (!initializationPromise) {
    initializationPromise = i18n
      .use(initReactI18next)
      .init({
        resources: {
          en: { translation: en },
          es: { translation: es },
          pt: { translation: pt },
        },
        lng: "en",
        fallbackLng: "en",
        supportedLngs: supportedLocales,
        interpolation: {
          escapeValue: false,
        },
        react: {
          useSuspense: false,
        },
      })
      .then(() => i18n);
  }

  return initializationPromise ?? Promise.resolve(i18n);
}

export async function setLocale(locale: SupportedLocale) {
  if (!supportedLocales.includes(locale)) {
    return;
  }

  if (!i18n.isInitialized) {
    await initializeI18n();
  }

  await i18n.changeLanguage(locale);
}

export { i18n };
